import i18next from 'i18next';

i18next.addResources('es', 'EmptyResult', {
  checkInformation: 'Verifique la información ingresada',
  noResults: 'No se encontraron resultados',
  noFiles: 'No hay {{name}} para mostrar'
});
